// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AttachmentThumbnail-cls1___39828ce144816b69741{/*!*/}.AttachmentThumbnail-cls2___828ba523beac5edd576{display:flex;justify-content:center;margin-bottom:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AttachmentThumbnail-cls1___39828ce144816b69741",
	"cls2": "AttachmentThumbnail-cls2___828ba523beac5edd576 AttachmentThumbnail-cls1___39828ce144816b69741"
};
export default ___CSS_LOADER_EXPORT___;
